import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { OnBoardingContext } from 'client/contexts/OnBoardingContext'
import { get } from 'client/utils/api-routes.util'
import {
  DcInput,
  PixelFactoryContext,
  DcButton,
  DcFlexBox,
  DcDropDown,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs/ajax'
import { registerCustomerStore } from 'utils/api-routes.util'
import { ICompunknownInfo, IPixelFactory } from '../../../../../decl.d'
import {
  FormElementContainer,
  FormFlex,
  FormInputGroup,
  SectionContainer,
  UpdateButtons,
} from '../styled.components'

const CompanyInfo = ({ onBack }: { onBack?: () => void }) => {
  const { updateCompunknownInfo } = React.useContext(OnBoardingContext)
  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [compunknownInfo, setCompunknownInfo] = useState<ICompunknownInfo>(
    {} as ICompunknownInfo,
  )
  const [formData, setFormData] = useState<ICompunknownInfo>({
    compunknown_name: '',
    compunknown_phone_number: '',
    compunknown_website: '',
    compunknown_email: '',
    whatsapp_number: '',
    compunknown_address: '',
    compunknown_city: '',
    compunknown_country: '',
    compunknown_zip: '',
    compunknown_state: '',
  })
  const [errors, setErrors] = useState<Record<string, string>>({})
  const getCompunknownInfo = () => {
    get('/tenant/company').subscribe((res) => {
      const response = res
      setCompunknownInfo(response.response as ICompunknownInfo)
    })
  }
  useEffect(() => {
    showLoader()
    getCompunknownInfo()
    hideLoader()
  }, [])

  useEffect(() => {
    if (compunknownInfo) {
      setFormData({
        compunknown_name: compunknownInfo.company_name || '',
        compunknown_phone_number: compunknownInfo.company_phone_number || '',
        compunknown_website: compunknownInfo.compunknown_website || '',
        compunknown_email: compunknownInfo.company_email || '',
        whatsapp_number: compunknownInfo.whatsapp_number || '',
        compunknown_address: compunknownInfo.compunknown_address || '',
        compunknown_city: compunknownInfo.compunknown_city || '',
        compunknown_country: compunknownInfo.compunknown_country || '',
        compunknown_zip: compunknownInfo.compunknown_zip || '',
        compunknown_state: compunknownInfo.compunknown_state || '',
      })
    }
  }, [compunknownInfo])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: '',
      }))
    }
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    showLoader()

    // Always call /tenant/stores/ems endpoint on continue
    registerCustomerStore({ store_type: 'ems' }).subscribe(
      (res: AjaxResponse<any>) => {
        // After EMS store is registered, update company info
        updateCompunknownInfo(formData)
        // Clear the flag if it exists
        localStorage.removeItem('fromWithoutWebsite')
      },
      (error) => {
        hideLoader()
        console.error('Error registering EMS store:', error)
        // Still try to update company info even if EMS registration fails
        updateCompunknownInfo(formData)
        localStorage.removeItem('fromWithoutWebsite')
      },
    )
  }

  return (
    <SectionContainer>
      <Form
        style={{ width: '100%', padding: '20px 0px' }}
        onSubmit={handleSubmit}
      >
        <FormElementContainer>
          <FormFlex>
            <FormInputGroup>
              <DcInput
                label="Company Name"
                // width="50%"
                name="compunknown_name"
                placeholder="Company Name"
                type="text"
                required
                error={errors.compunknown_name}
                value={formData.compunknown_name}
                onChange={handleChange}
              />
            </FormInputGroup>
            <FormInputGroup>
              <DcInput
                label="Company Email"
                name="compunknown_email"
                placeholder="Company Email"
                type="email"
                required
                error={errors.compunknown_email}
                value={formData.compunknown_email}
                onChange={handleChange}
              />
            </FormInputGroup>
          </FormFlex>
          <FormFlex>
            <FormInputGroup>
              <DcInput
                label="Company Phone"
                name="compunknown_phone_number"
                placeholder="Company Phone"
                type="tel"
                required
                error={errors.compunknown_phone_number}
                value={formData.compunknown_phone_number}
                onChange={handleChange}
              />
            </FormInputGroup>
            <FormInputGroup>
              <DcInput
                label="WhatsApp Number"
                // width="50%"
                name="whatsapp_number"
                placeholder="WhatsApp Number"
                type="tel"
                required
                error={errors.whatsapp_number}
                value={formData.whatsapp_number}
                onChange={handleChange}
              />
            </FormInputGroup>
          </FormFlex>
          <FormFlex>
            <DcFlexBox
              width="100%"
              height="auto"
              flexDirection="column"
              alignItems="flex-start"
              alignContent="flex-start"
              gap="12px"
              margin="0px 0px 10px 0px"
            >
              <DcInput
                label="Company Website"
                // width="50%"
                name="compunknown_website"
                placeholder="Company Website"
                type="url"
                required
                error={errors.compunknown_website}
                value={formData.compunknown_website}
                onChange={handleChange}
              />

              <DcInput
                label="Company Address"
                // width="100%"
                name="compunknown_address"
                placeholder="Company Address"
                type="text"
                required
                error={errors.compunknown_address}
                value={formData.compunknown_address}
                onChange={handleChange}
              />
            </DcFlexBox>
          </FormFlex>
          <FormFlex>
            <FormInputGroup>
              <DcInput
                label="City"
                // width="50%"
                name="compunknown_city"
                placeholder="City"
                type="text"
                required
                error={errors.compunknown_city}
                value={formData.compunknown_city}
                onChange={handleChange}
              />
            </FormInputGroup>
            <FormInputGroup>
              <DcInput
                label="State"
                // width="50%"
                name="compunknown_state"
                placeholder="State"
                type="text"
                required
                error={errors.compunknown_state}
                value={formData.compunknown_state}
                onChange={handleChange}
              />
            </FormInputGroup>
          </FormFlex>
          <FormFlex>
            <FormInputGroup>
              <DcInput
                label="ZIP Code"
                // width="50%"
                name="compunknown_zip"
                placeholder="ZIP Code"
                type="text"
                required
                error={errors.compunknown_zip}
                value={formData.compunknown_zip}
                onChange={handleChange}
              />
            </FormInputGroup>
            <FormInputGroup>
              <DcDropDown
                // width="50%"
                name="compunknown_country"
                label="Country"
                placeholder="Select Country"
                required
                options={[
                  { label: 'Pakistan', value: 'PK' },
                  { label: 'USA', value: 'US' },
                ]}
                error={errors.compunknown_country}
                value={formData.compunknown_country}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    compunknown_country: e.target.value,
                  }))
                }}
              />
            </FormInputGroup>
          </FormFlex>
        </FormElementContainer>
        <UpdateButtons>
          <DcButton width="100%" variant="gradient" type="submit">
            Update Company Info
          </DcButton>
        </UpdateButtons>
      </Form>
    </SectionContainer>
  )
}

export default CompanyInfo
